// Externe Bibliotheken
import React, { Component } from 'react';

// Interne Module
import { checkIsAllowToBookService } from '@/_helper/checkAccess';
import tracking from '@/_helper/tracking';
import * as storage from '@/_helper/storage';

// Komponenten
import Header from '@/comp/header/header';
import Footer from '@/comp/footer/Footer';
import Form from './Form';
import HeroTeaser from '@/comp/heroTeaser';
import { DetectMultipleTabs } from '@/comp/multipleTabs/multipleTabs';

// Styles
import './railAndFly.scss';

class Index extends Component {
    state = {
        bookingData: {},
    };

    componentDidMount() {
        const bookingData = storage.get('bookingData') !== null ? storage.get('bookingData') : {};

        if (bookingData?.data?.allowRailAndFly && checkIsAllowToBookService('railAndFly')) {
            document.title = 'Zug zum Flug' + window.$documentTitle;
            document.querySelector('html').classList.add('redesign');

            tracking('loaded', 'railAndFly');

            this.setState({
                bookingData: bookingData,
            });
        } else {
            window.location.href = '/';
        }
    }

    render() {
        return (
            <div className="page-railAndFly">
                <DetectMultipleTabs travelType="railAndFly" />

                <Header />

                <HeroTeaser />

                <div className="content-wrapper">
                    <div className="intro row">
                        <h1 className="main-headline col">Zug zum Flug</h1>
                    </div>

                    <div className="row">
                        <p>
                            Wählen Sie jetzt ein passendes <b>Zug zum Flug</b> Angebot aus.
                        </p>
                        <p>
                            Alle Rail&Fly-Tickets sind nur in Kombination mit einer internationalen Flugleistung gültig.
                            <br />
                            Alle Details zu den Konditionen finden Sie{' '}
                            <a
                                target="_blank"
                                href={`${window.$website}/service/railandfly-konditionen`}
                                rel="noopener noreferrer">
                                hier
                            </a>
                            .
                        </p>

                        <Form />
                    </div>
                </div>

                <Footer />
            </div>
        );
    }
}

export default Index;
